import * as types from "./actionTypes";

export const markDocumentReadDavinFoods = (documentFilename) => ({
  type: types.MARK_DOCUMENT_READ_DAVIN_FOODS,
  payload: documentFilename,
});

export const setDavinFoodsReadingLoading = (isLoading) => {
  return {
    type: types.SET_DAVIN_FOODS_READING_LOADING,
    payload: isLoading,
  };
};

export const submitDavinFoodsQuiz = (formName, formContent) => ({
  type: types.SUBMIT_DAVIN_FOODS_QUIZ,
  payload: { formName, formContent },
});

export const setDavinFoodsQuizLoading = (quizName) => {
  return {
    type: types.SET_DAVIN_FOODS_QUIZ_LOADING,
    payload: quizName,
  };
};

export const setDavinFoodsQuizResults = (results) => ({
  type: types.SET_DAVIN_FOODS_QUIZ_RESULTS,
  payload: results,
});

export const postDavinFoodsForm = (formName, formContent) => ({
  type: types.POST_DAVIN_FOODS_FORM,
  payload: { formName, formContent },
});

export const submitDavinFoodsForm = (formName, formContent, typeCode) => ({
  type: types.SUBMIT_DAVIN_FOODS_FORM,
  payload: { formName, formContent, typeCode },
});

export const setDavinFoodsQuizShowResults = (quizName) => {
  return {
    type: types.SET_DAVIN_FOODS_QUIZ_SHOW_RESULTS,
    payload: quizName,
  };
};
